import { createAction } from 'redux-actions'

const MESSAGE = 'MESSAGE'
const WIPE_OUT = 'WIPE_OUT'

const actions = {
    message: createAction(MESSAGE),
    wipeOut: createAction(WIPE_OUT)
}

const types = {
    MESSAGE,
    WIPE_OUT
}

export { actions, types }



// WEBPACK FOOTER //
// ./src/store/actions/misc.js